import FieldController from '../field.controller';
import { convertStringToBoolean } from '../../../util';

class AgreementCheckboxFieldController extends FieldController {
  get value() {
    let value = super.value;
    if (value !== null && value !== undefined) {
      value = convertStringToBoolean(value.toString());
    }
    return value;
  }

  set value(value) {
    if (!!value) {
      super.value = 1;
    } else {
      super.value = 0;
    }
  }
}

export default AgreementCheckboxFieldController;
